import Layout from "../components/Layout";
import BuySell from "../components/_BuySell";

const BuySellPage = (props:any) => {
    return (
    <Layout>
        <BuySell />
    </Layout>
    )
}

export default BuySellPage